const accordion = {
    applyState($root) {
        if (this.isMobile()) {
            this.toMobile($root);
        } else {
            this.toDesktop($root);
        }
    },
    init(selector) {
        const $root = $(selector);
        if (!$root.length) {
            return;
        }
        this.setHandlers($root);
        this.applyState($root);
        this.setResizeHandler($root);
    },
    isMobile() {
        return window.innerWidth < this.locals.BREAKPOINT;
    },
    locals: {
        BREAKPOINT: 992,
        RESIZE_BOUND: false,
    },
    setHandlers($root) {
        $root.on("click", ".accordion__toggle", function () {
            const $group = $(this).closest(".accordion__group");
            if (!$group.hasClass("accordion__group--simple") && !accordion.isMobile()) {
                return;
            }
            const $section = $(this).closest(".accordion__section");
            const $content = $section.children(".accordion__content");
            $section.toggleClass("active");
            if ($section.hasClass("active")) {
                $content.css("max-height", $content[0].scrollHeight + "px");
            } else {
                $content.css("max-height", "");
            }
        });
    },
    setResizeHandler($root) {
        if (this.locals.RESIZE_BOUND) {
            return;
        }
        let lastMode = this.isMobile();
        $(window).on("resize", () => {
            const currentMode = accordion.isMobile();
            if (currentMode !== lastMode) {
                accordion.applyState($root);
                lastMode = currentMode;
            }
        });
        this.locals.RESIZE_BOUND = true;
    },
    toDesktop($root) {
        $root.find(".accordion__section").each(function () {
            const $section = $(this);
            const $content = $section.find(".accordion__content");
            $section.removeClass("active");
            $content.css("max-height", "");
        });
    },
    toMobile($root) {
        $root.find(".accordion__section").each(function () {
            const $section = $(this);
            const $content = $section.find(".accordion__content");
            $section.removeClass("active");
            $content.css("max-height", "");
        });
    },
};